module.exports = __webpack_public_path__ + "static/media/logo-preto.b74e50b7.png";